import { render, staticRenderFns } from "./Capitales.vue?vue&type=template&id=1e8bcfd2&scoped=true&"
import script from "./Capitales.vue?vue&type=script&lang=js&"
export * from "./Capitales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8bcfd2",
  null
  
)

export default component.exports